import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UpdateTableComponent } from './update-table.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from 'src/app/shared/material/material.module';
import { MatPaginatorModule } from '@angular/material/paginator';
import { CustomTimpickerModule } from '../../shared/components/custom-timpicker/custom-timpicker.module';
import { CustomDatePickerModule } from 'src/app/shared/components/custom-date-picker/custom-date-picker.module';
import { CustomDropdownModule } from 'src/app/shared/components/custom-dropdown/custom-dropdown.module';
import { CurrentVoyagesModule } from '../current-voyages/current-voyages.module';
import { PastVoyagesModule } from '../past-voyages/past-voyages.module';
import { UpdateTableRoutingModule } from './update-table-routing.module';

@NgModule({
  declarations: [UpdateTableComponent],
  exports: [UpdateTableComponent],
  imports: [
    CommonModule,
    FormsModule,
    CustomDropdownModule,
    CustomDatePickerModule,
    ReactiveFormsModule,
    MaterialModule,
    MatPaginatorModule,
    CustomTimpickerModule,
    CurrentVoyagesModule,
    PastVoyagesModule,
    UpdateTableRoutingModule
  ],
})
export class UpdateTableModule {}
